export const achievementData = {
    bio : "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. - Alvin Toffler",
    achievements : [
        {
            id : 1,
            title : '2021 Complete Python Bootcamp From Zero to Hero in Python',
            details : 'A python course from Udemy',
            date : 'Jan 28, 2021',
            field : 'Coding',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-0cd075aa-f55b-4d9f-aec0-119020a4e792.jpg?v=1611846350000'
        },
        {
            id : 2,
            title : 'The Ultimate MySQL Bootcamp: Go from SQL Beginner to Expert',
            details : 'A MySQL course from Udemy',
            date : 'May 25, 2021',
            field : 'Database',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-91ae3ea2-39ee-4a57-bf23-d397aff0d9a7.jpg?v=1621951317000'
        },
        {
            id : 3,
            title : 'Machine Learning A-Z: Hands-On Python & R in Data Science',
            details : 'Data Science Course from Udemy',
            date : 'Apr 13, 2021',
            field : 'Machine Learning',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-d9a7ba99-8635-47e6-96fc-7dd26a3dcbf1.jpg?v=1618297236000'
        },
        {
            id : 3,
            title : 'R Programming A-Z: R For Data Science With Real Exercises!',
            details : 'R Programming Language Course from Udemy',
            date : 'Feb 28, 2021',
            field : 'Data Science',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-8f5ff8e8-b6a4-4efd-a3fc-7fb63b29e77f.jpg?v=1614489452000'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/